/**
 * Fragrenza — Sticky Add-to-Cart Bar
 * Appears when the main ATC button scrolls out of view.
 * Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  class StickyATC {
    constructor() {
      this.bar = document.getElementById('fragrenza-sticky-atc');
      // Find the active product form. Dawn renders <product-form> wrapping a
      // <form action="/cart/add"...>; the form's id is dynamic (product-form-<sectionId>),
      // so we locate it by structure rather than literal id.
      this.mainForm = document.querySelector('product-form form[action*="/cart/add"]')
        || document.querySelector('section[id^="MainProduct"] form[action*="/cart/add"]');
      this.mainBtn = this.mainForm && this.mainForm.querySelector('[name="add"]');
      if (!this.bar || !this.mainForm || !this.mainBtn) return;

      this.stickyBtn = this.bar.querySelector('.fatc__btn');
      this.stickyTitle = this.bar.querySelector('.fatc__title');
      this.stickyVariant = this.bar.querySelector('.fatc__variant');
      this.stickyPrice = this.bar.querySelector('.fatc__price');

      this.isVisible = false;
      this.ticking = false;

      this.bindEvents();
      this.syncVariant();
    }

    bindEvents() {
      window.addEventListener('scroll', () => {
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.onScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }, { passive: true });

      // Sync when variant changes
      document.addEventListener('variant:change', e => this.onVariantChange(e));

      // ATC click — submit the main form
      this.stickyBtn && this.stickyBtn.addEventListener('click', () => {
        this.mainBtn.click();
      });
    }

    onScroll() {
      const rect = this.mainBtn.getBoundingClientRect();
      const hidden = rect.bottom < 0;

      if (hidden && !this.isVisible) {
        this.bar.classList.add('is-visible');
        this.isVisible = true;
      } else if (!hidden && this.isVisible) {
        this.bar.classList.remove('is-visible');
        this.isVisible = false;
      }
    }

    syncVariant() {
      // Read initial state from the page
      const titleEl = document.querySelector('.product__title h1, .product__title');
      if (titleEl && this.stickyTitle) {
        this.stickyTitle.textContent = titleEl.textContent.trim();
      }

      const priceEl = document.querySelector('.price__regular .price-item--regular');
      if (priceEl && this.stickyPrice) {
        this.stickyPrice.textContent = priceEl.textContent.trim();
      }

      const variantEl = document.querySelector('.product-form__input input[type="radio"]:checked + label, .product-form__input option:checked');
      if (variantEl && this.stickyVariant) {
        this.stickyVariant.textContent = variantEl.textContent.trim();
      }
    }

    onVariantChange(e) {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;

      if (this.stickyVariant) {
        this.stickyVariant.textContent = variant.title !== 'Default Title' ? variant.title : '';
      }

      if (this.stickyPrice) {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: Shopify.currency.active || 'USD',
          minimumFractionDigits: 2
        });
        this.stickyPrice.textContent = formatter.format(variant.price / 100);
      }

      // Mirror availability on sticky button
      if (this.stickyBtn) {
        this.stickyBtn.disabled = !variant.available;
        this.stickyBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new StickyATC());
  } else {
    new StickyATC();
  }
})();
